import React, { useState } from "react";
import { Formik, Form } from "formik";
import { ForgotPasswordSchema } from "../../Schemas/Forgot Password/forgotPasswordSchema";
import { ForgotPasswordInfo } from "../../SchemaInfo/info";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import CustomInput from "../../CustomComponent/custom_input";
import Footer from "../../Components/Footer/footer";
import { AiOutlineMail, AiOutlineSend } from "react-icons/ai"; // Icons for input and button
import { Link } from "react-router-dom";

const ForgetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);

  const handleSubmit = (values) => {
    setLoading(true);
    performRequest("POST", "/password/forgot-password/", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", `${res.data.message}`);
        } else {
          Toast("error", "Error while processing request!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="page page-wrapper d-flex flex-column justify-content-center align-items-center vh-100 mt-8">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card shadow-lg">
              <div className="card-body">
                {/* Header with Logo and Title */}
                <div className="text-center mb-4">
                  <h1 className="fs-large m-0 text-primary">αlpha</h1>
                  <p className="fs-5 text-success">by KRYZEN</p>
                </div>

                {/* Card Title */}
                <h2 className="card-title text-center mb-3">
                  Forgot Password?
                </h2>
                <p className="text-muted text-center">
                  Enter your email address and we’ll send you a password reset
                  link.
                </p>

                {/* Formik Form */}
                <Formik
                  initialValues={ForgotPasswordInfo}
                  validationSchema={ForgotPasswordSchema}
                  onSubmit={handleSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="mb-3">
                        <label className="form-label">Email address</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <AiOutlineMail size={20} />
                          </span>
                          <CustomInput
                            name="email"
                            placeholder="Enter email"
                            type="email"
                          />
                        </div>
                        {props.touched.email && props.errors.email && (
                          <p className="text-danger">{props.errors.email}</p>
                        )}
                      </div>

                      {/* Submit Button */}
                      <div className="d-grid">
                        <button
                          className={`btn btn-primary ${
                            !disable ? "disabled" : ""
                          }`}
                          type="submit"
                          disabled={loading}
                          onClick={() => setDisable(false)}
                        >
                          {loading ? "Processing..." : "Send Reset Link"}{" "}
                          <AiOutlineSend className="ms-1" />
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>

                {/* Back to Login */}
                <div className="text-center mt-3">
                  <p className="text-muted">
                    Remember your password?{" "}
                    <Link to="/account-login" className="text-primary">
                      Go back to login
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgetPassword;
